<template>
  <b-card no-body>
    <b-card-body id="pickup-detail-card-body">
      <pickup-detail-filter
        :values="filterValues"
        :filter-submitting="isLoading"
        @filter="setFilter"
      />

      <vue-good-table
        mode="remote"
        :sort-options="{ enabled: false }"
        :is-loading.sync="isLoading"
        :show-footer="true"
        :pagination-options="{
          enabled: true,
          jumpFirstOrLast: true,
          rowsPerPageLabel: t('Rows per page'),
          ofLabel: t('ofLabel'),
          nextLabel: t('nextLabel'),
          prevLabel: t('prevLabel'),
          dropdownAllowAll: false
        }"
        :rows="rows"
        :columns="getColumns"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'reference_number'">
            {{ props.row.reference_number }}
          </span>
          <span v-else-if="props.column.field === 'barcode'">
            {{ props.row.barcode }}
          </span>
          <span v-else-if="props.column.field === 'desi'">
            {{ props.row.desi }}
          </span>
          <span v-else-if="props.column.field === 'weight'">
            {{ props.row.weight }}
          </span>
          <span v-else-if="props.column.field === 'status'">
            <b-badge
              pill
              class="text-white"
              :variant="props.row.status === 'picked_up' ? 'success' : 'warning'"
            >
              {{ getConsignmentStatus(props.row.status) || props.row.status }}
            </b-badge>
          </span>
          <span v-else-if="props.column.field === 'drop_off_event_at'">
            {{
              props.row.drop_off_event_at ? formatDateToCustom(props.row.drop_off_event_at) : '-'
            }}
          </span>
        </template>
      </vue-good-table>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BBadge } from 'bootstrap-vue';
import { VueGoodTable } from 'vue-good-table';
import useService from '@/auth/service/useService';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import PickupDetailFilter from '@/views/pages/pickups/PickupDetailFilter.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'PickupDetailPage',
  components: {
    PickupDetailFilter,
    BCard,
    BCardBody,
    BBadge,
    VueGoodTable
  },
  mixins: [helper],
  data() {
    return {
      isLoading: false,
      pickupDetailData: {},
      rows: [],
      pagination: {
        page: 1,
        limit: 10
      },
      filterValues: {
        barcode: '',
        status: ''
      }
    };
  },
  computed: {
    ...mapGetters({
      pickupConsignmentStatus: 'app/pickupConsignmentStatus'
    }),
    getColumns() {
      if (!this.rows.length) {
        return [];
      }

      return [
        { label: this.$t('Reference Number'), field: 'reference_number' },
        { label: this.$t('Barcode'), field: 'barcode' },
        { label: this.$t('Desi'), field: 'desi' },
        { label: this.$t('Weight'), field: 'weight' },
        { label: this.$t('Status'), field: 'status' },
        { label: this.$t('Movement Time'), field: 'drop_off_event_at' }
      ];
    }
  },
  async created() {
    if (this.pickupConsignmentStatus.length < 1) {
      await this.$store.dispatch('app/getPickupConsignmentStatusLabels');
    }
    this.loadItems();
  },
  methods: {
    onPageChange(params) {
      this.pagination.page = params.currentPage;
    },
    onPerPageChange(params) {
      this.pagination.page = 1;
      this.pagination.limit = params.currentPerPage;
    },
    loadItems() {
      const id = this.$route.params.id;
      this.isLoading = true;

      const params = {
        ...this.filterValues,
        page: this.pagination.page,
        limit: this.pagination.limit
      };

      useService.pickupService
        .getPickup(id, params)
        .then(res => {
          this.pickupDetailData = res.data;
          this.rows = res.data.consignments || [];
        })
        .catch(err => {
          this.showErrorMessage(err.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setFilter(data) {
      this.filterValues = data;
      this.pagination.page = 1;
      this.loadItems();
    },
    getConsignmentStatus(status) {
      const item = this.pickupConsignmentStatus.find(x => x.value === status);

      if (item) {
        return item.text;
      }

      return '';
    }
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
